import React from 'react';
import cartIcon from '../../assets/category-icons/cart-icon.svg';

const Cart = () => {
  return (
    <div className='cart'>
      <img src={cartIcon} alt='cart icon' />
    </div>
  )
}

export default Cart
